module.exports = __webpack_public_path__ + "img/encours.80185626.png";